/**
 * The sign-up application's access token, kept in sessionStorage keyed by its
 * reference — shared by the sign-up chatbot and the status page, which hands the
 * chatbot a token when an application has a step to take.
 */

const tokenKey = (ref) => `pbdq_signup:${ref}`;

export const saveToken = (ref, token) => {
    try { sessionStorage.setItem(tokenKey(ref), token); } catch (_) { /* private mode */ }
};

export const readToken = (ref) => {
    try { return sessionStorage.getItem(tokenKey(ref)); } catch (_) { return null; }
};

/*
 * The chat's hand-over to the DQ Pro V2 sign-up page (/signup): what the chat
 * collected before handing over — after DS-3 on the direct route, after DP-5 on
 * the DQ Pro route. Kept in sessionStorage so a reload of /signup keeps it; it
 * lapses after HANDOVER_TTL_MS and is cleared once the page has used it.
 */
const HANDOVER_KEY = 'pbdq_signup:handover';
const HANDOVER_TTL_MS = 2 * 60 * 60 * 1000;

/** @param {{ route: 'direct'|'dq_pro', solution: string, deployment?: object, quote?: object, source_page?: string }} handover */
export const saveHandover = (handover) => {
    try { sessionStorage.setItem(HANDOVER_KEY, JSON.stringify({ ...handover, at: Date.now() })); } catch (_) { /* private mode */ }
};

export const readHandover = () => {
    try {
        const h = JSON.parse(sessionStorage.getItem(HANDOVER_KEY) || 'null');
        if (!h || !h.route || !h.at || Date.now() - h.at > HANDOVER_TTL_MS) return null;
        return h;
    } catch (_) { return null; }
};

export const clearHandover = () => {
    try { sessionStorage.removeItem(HANDOVER_KEY); } catch (_) { /* private mode */ }
};
